import type { TPreparedVitrinsOffer } from 'shared/types/TVitrinsService';

import { buildCreditCardSummary } from 'entities/vitrins/lib/buildCreditCardSummary';
import { buildCreditSummary } from 'entities/vitrins/lib/buildCreditSummary';

export const buildSummary = (offer: TPreparedVitrinsOffer) => {
  const isServer = typeof window === 'undefined';

  switch (offer.type) {
    case 'credit': {
      return buildCreditSummary(offer, isServer);
    }
    case 'creditCard': {
      return buildCreditCardSummary(offer);
    }
    default: {
      return [];
    }
  }
};
